import { SettingsParser } from "./settings-parser";
import { DataSourceCommonSettings } from "../settings/data-source-common-settings";

export class CommonDataSourceParser extends SettingsParser {
  constructor(channelParser, markParser) {
    super();
    this.parsedFieldNames = [
      "id",
      "channels",
      "channel", // from default settings
      "marks",
      "mark" // from default settings
    ];
    this.channelParser = channelParser;
    this.markParser = markParser;
  }

  static createSettings(settings, defaultSettings, channelParser, markParser) {
    if (settings === undefined) {
      return undefined;
    }
    const parsedSettings = {
      id: settings.id
    };
    if (settings.channels !== undefined && channelParser !== undefined) {
      parsedSettings.channels = [];
      for (let channelIndex = 0; channelIndex < settings.channels.length; channelIndex++) {
        const channelSettings = channelParser.parse(settings.channels[channelIndex], defaultSettings?.channel);
        if (channelSettings !== undefined) {
          parsedSettings.channels.push(channelSettings);
        }
      }
    }
    if (settings.marks !== undefined && markParser !== undefined) {
      parsedSettings.marks = [];
      for (let markIndex = 0; markIndex < settings.marks.length; markIndex++) {
        const markSettings = markParser.parse(settings.marks[markIndex], defaultSettings?.mark);
        if (markSettings !== undefined) {
          parsedSettings.marks.push(markSettings);
        }
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = CommonDataSourceParser.createSettings(settings, defaultSettings, this.channelParser, this.markParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new DataSourceCommonSettings(parsedSettings);
  }
}
